import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export const TOUR_3D_CHANGED_TYPE = 'filters/tour_3d/TOUR_3D_CHANGED';

export interface ITour3dChangedAction {
  type: 'filters/tour_3d/TOUR_3D_CHANGED';
  value: boolean | undefined;
}

export function changeTour3d(value: boolean | undefined): ITour3dChangedAction {
  return {
    type: 'filters/tour_3d/TOUR_3D_CHANGED',
    value,
  };
}

export function tour3dReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/tour_3d/TOUR_3D_CHANGED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jsonQuery.setTour3d(action.value || undefined),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'tour-3d') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: {
              ...state.filters.jsonQuery,
              tour_3d: undefined,
            },
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            tour_3d: undefined,
          },
        },
      };

    default:
      return state;
  }
}
